{
  "title": "Notifications",
  "empty": {
    "title": "Nothing coming up",
    "hint": "Birthdays, upcoming leaves and holidays will appear here."
  },
  "when": {
    "today": "Today",
    "tomorrow": "Tomorrow",
    "inDays": "In {{count}} days"
  },
  "events": {
    "birthday": "{{name}} turns {{turns}}",
    "timeOffStart": "{{name}} — {{type}} starts (until {{end}})",
    "timeOffEnd": "{{name}} returns to work",
    "holiday": "Holiday: {{name}}"
  },
  "dropdownHint": "Next 14 days"
}
